import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  spacing,
  lineHeights,
  fontSizes,
  palette,
}: Theme) => ({
  actions: {
    display: 'grid',
    gap: spacing(3),
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
      gap: spacing(3.5),
    },
  },
  veeva: {
    position: 'absolute',
    left: '0.25rem',
    top: '0.25rem',
    color: palette.grey[200],
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
